export const SENSORS_LOADING_MESSAGE="Estamos consultando la información de tus sensores";
export const ERROR_401_MESSAGE="Ups, parece que te has estado inactivo por mucho tiempo. Ingresa nuevamente ";
export const GRAPHS_LOADING_MESSAGE="Estamos cargando los datos de tus sensores";